import request from 'utils/request'
import { fail, success } from 'utils/actionCreator'

const { REACT_APP_API_URL: API_URL } = process.env

const hasProfiles = r => success(`GET_GA_${'name' in r[0] ? 'PROFILES' : 'ANALYTICS'}`, r)

export const connectGoogle = (data, date) => dispatch =>
  request.post(`${API_URL}/service?date=${date}`, data)
    .then(response => dispatch(hasProfiles(response)))
    .catch(error => dispatch(fail('GET_GA_USERS', error)))